import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_2 = { class: "flex flex-col justify-center w-full space-y-6" }
const _hoisted_3 = { class: "flex flex-row justify-between" }
const _hoisted_4 = { class: "flex flex-row items-center space-x-8" }
const _hoisted_5 = { class: "text-2xl font-semibold text-gray-500" }
const _hoisted_6 = { class: "flex flex-row justify-between pr-2 text-sm text-gray-400 items-centerr" }
const _hoisted_7 = { class: "flex flex-row space-x-4" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "flex flex-row items-center space-x-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

import { formatDate } from "@/utils";
import { inject, onBeforeMount, onMounted, ref } from "vue";

	/**
	 * Variables
	 */
	
export default /*#__PURE__*/_defineComponent({
  __name: 'ExpeditionsList',
  setup(__props) {

const isLoading: any = ref(inject("isLoading"));
	const expeditionsData: any = ref(inject("expeditionsData"));
	const handlePageChange: any = ref(inject("handlePageChange"));
	const setSelectedExpedition: any = ref(inject("setSelectedExpedition"));
	const openModalToCHangeExpeditionStatus: any = ref(inject("openModalToCHangeExpeditionStatus"));
	const currentExpeditionInTransitTab: any = ref(inject("currentExpeditionInTransitTab"));

  onBeforeMount(() => {
    //
  })

  onMounted(() => {
    //
  })

return (_ctx: any,_cache: any) => {
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_CardWidget = _resolveComponent("CardWidget")!
  const _component_PaginationTag = _resolveComponent("PaginationTag")!
  const _component_EmptyTag = _resolveComponent("EmptyTag")!
  const _component_CardEmbarkationSkeleton = _resolveComponent("CardEmbarkationSkeleton")!
  const _component_SkeletonLoader = _resolveComponent("SkeletonLoader")!

  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expeditionsData.value.items, (item) => {
          return (_openBlock(), _createBlock(_component_CardWidget, {
            css: "!h-[100px] pr-4 mb-4 flex flex-row w-full hover:bg-[#0D180C] cursor-pointer",
            key: item.id,
            onClick: ($event: any) => (setSelectedExpedition.value(item))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass({
          'border-l-2 h-full mr-4': true,
          // L'API expose `status_ref` (cf. ExpeditionResource). L'ancien
          // `status.code` ne correspondait à rien (status = libellé string)
          // → couleur jamais appliquée. On s'aligne sur status_ref.
          'border-l-[#F1AC5E]': item?.status_ref === 'pending-shipment', // En attente d'expédition
          'border-l-blue-500': item?.status_ref === 'in-transit', // En transit
          'border-l-accent': item?.status_ref === 'arrived-at-destination', // Arrivé à destination
          'border-l-red-400': item?.status_ref === 'cancelled', // Annulé
        })
              }, null, 2),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(item?.label), 1),
                    _createElementVNode("p", {
                      class: _normalizeClass({
                'text-[#F1AC5E]': item.status_ref === 'pending-shipment', // Planifié (number_of_places == 0)
                'text-blue-500': item.status_ref === 'in-transit', // en chemin
                'text-accent':
                  item.status_ref === 'arrived-at-destination', // Arrive a destination
                'text-red-400': item.status_ref == 'cancelled', // Annulé
              })
                    }, _toDisplayString(`Statut actuel: ${item.status_fr}`), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, "Véhicule: " + _toDisplayString(item.vehicle?.vehicle_type ?? 'Non défini'), 1),
                    _createElementVNode("span", null, [
                      _createTextVNode("Immatriculation: "),
                      _createElementVNode("strong", _hoisted_8, _toDisplayString(item.vehicle?.matriculation_no), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _createTextVNode("Chauffeur: "),
                      _createElementVNode("strong", _hoisted_9, _toDisplayString(item.driver?.name), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _createTextVNode("Créé le "),
                      _createElementVNode("strong", _hoisted_10, _toDisplayString(_unref(formatDate)(item.created_at, 3)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (item.status_ref !== 'cancelled' && item.status_ref !== 'arrived-at-destination')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Modifier le statut actuel : "))
                      : (_openBlock(), _createElementBlock("p", _hoisted_13, "Statut non modifiable")),
                    (item.status_ref !== 'cancelled' && item.status_ref !== 'arrived-at-destination' && currentExpeditionInTransitTab.value !== 'all-expeditions-in-transit')
                      ? (_openBlock(), _createBlock(_component_ButtonTag, {
                          key: 2,
                          label: "En attente",
                          disabled: true,
                          activeIcon: false,
                          icon: "/media/icons/add-icon.svg",
                          onClick: _withModifiers(() => openModalToCHangeExpeditionStatus.value(item, 'pending-shipment'), ["stop"]),
                          css: `${item.status_ref === 'pending-shipment' ? 'bg-accent' : 'bg-secondary' } border-secondary ${item.status_ref === 'pending-shipment' ? 'text-black' : 'text-white' } px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none`
                        }, null, 8, ["onClick", "css"]))
                      : _createCommentVNode("", true),
                    (item.status_ref !== 'cancelled' && item.status_ref !== 'arrived-at-destination')
                      ? (_openBlock(), _createBlock(_component_ButtonTag, {
                          key: 3,
                          label: "En transit",
                          activeIcon: false,
                          icon: "/media/icons/add-icon.svg",
                          onClick: _withModifiers(() => openModalToCHangeExpeditionStatus.value(item, 'in-transit'), ["stop"]),
                          css: `${item.status_ref === 'in-transit' ? 'bg-accent' : 'bg-secondary' } border-secondary ${item.status_ref === 'in-transit' ? 'text-black' : 'text-white' } text-white px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none`
                        }, null, 8, ["onClick", "css"]))
                      : _createCommentVNode("", true),
                    (item.status_ref !== 'cancelled' && item.status_ref !== 'arrived-at-destination')
                      ? (_openBlock(), _createBlock(_component_ButtonTag, {
                          key: 4,
                          label: "A destination",
                          activeIcon: false,
                          icon: "/media/icons/add-icon.svg",
                          onClick: _withModifiers(() => openModalToCHangeExpeditionStatus.value(item, 'arrived-at-destination'), ["stop"]),
                          css: `${item.status_ref === 'arrived-at-destination' ? 'bg-accent' : 'bg-secondary' } border-secondary ${item.status_ref === 'arrived-at-destination' ? 'text-black' : 'text-white' } text-white px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none`
                        }, null, 8, ["onClick", "css"]))
                      : _createCommentVNode("", true),
                    (item.status_ref !== 'cancelled' && item.status_ref !== 'arrived-at-destination' && item.status_ref !== 'in-transit' && currentExpeditionInTransitTab.value !== 'all-expeditions-in-transit')
                      ? (_openBlock(), _createBlock(_component_ButtonTag, {
                          key: 5,
                          label: "Annuler",
                          activeIcon: false,
                          icon: "/media/icons/add-icon.svg",
                          onClick: _withModifiers(() => openModalToCHangeExpeditionStatus.value(item, 'cancelled'), ["stop"]),
                          css: `${item.status_ref === 'cancelled' ? 'bg-accent' : 'bg-secondary' } border-secondary ${item.status_ref === 'cancelled' ? 'text-black' : 'text-white' } text-white px-4 py-2 hover:bg-secondary-700 w-full active:bg-secondary-800  focus:outline-none`
                        }, null, 8, ["onClick", "css"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128)),
        _createVNode(_component_PaginationTag, {
          meta: expeditionsData.value.meta,
          onPageChange: handlePageChange.value
        }, null, 8, ["meta", "onPageChange"]),
        (expeditionsData.value.items && expeditionsData.value.items.length == 0 && !isLoading.value)
          ? (_openBlock(), _createBlock(_component_EmptyTag, {
              key: 0,
              heightt: 'calc(100vh - 25rem)'
            }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(_component_SkeletonLoader, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_CardEmbarkationSkeleton, { start: 6 })
        ]),
        _: 1
      }))
}
}

})